import { Link } from 'react-router-dom';

import { IconChevronDown } from '../icons';
import { useClientFarms } from '../contexts/farms';
import { envelopeData } from '../../core/network/envelope';

import '../styles/farm-select.css';

// TSS vite/01 — selector de finca compartido. Alimentado por useClientFarms
// (common/, D-003). Vive en common/ porque lo consumen ≥2 features: receptoras
// (farm_id) y donadoras-externas (origin_farm_id).
//
// Empty-state: si el cliente no tiene fincas, muestra un CTA a /fincas en vez
// del <select> (y el form bloquea el submit). El error (borde --error) lo
// controla el form vía la prop `error`; el mensaje lo pinta el <Field> que lo
// envuelve. Devuelve number|null en onChange (farm_id es int en el contrato).
export default function FarmSelect({ value, onChange, error = false, allowEmpty = true, disabled = false }) {
    const { data, isLoading } = useClientFarms({ limit: 500, offset: 0 });
    const farms = envelopeData(data).items ?? [];

    if (!isLoading && farms.length === 0) {
        return (
            <div className="farm-select farm-select--empty">
                <span className="farm-select__empty-text">Aún no tienes fincas.</span>
                <Link to="/fincas" className="farm-select__empty-cta">Crea una finca primero →</Link>
            </div>
        );
    }

    return (
        <div className={`farm-select ${error ? 'farm-select--error' : ''}`}>
            <select
                className={`farm-select__control ${error ? 'farm-select__control--error' : ''}`}
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value ? Number(e.target.value) : null)}
                disabled={disabled || isLoading}
            >
                {allowEmpty && (
                    <option value="">{isLoading ? 'Cargando fincas…' : 'Selecciona una finca'}</option>
                )}
                {farms.map((farm) => (
                    <option key={farm.id} value={farm.id}>{farm.name}</option>
                ))}
            </select>
            <span className="farm-select__chevron" aria-hidden="true"><IconChevronDown /></span>
        </div>
    );
}
